import './EmailVerified.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function EmailVerified() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="email-verified-container">
      <div className="email-verified-card">
        <div className="email-verified-icon">✓</div>
        <h1>{t('emailVerified.title')}</h1>
        <p>{t('emailVerified.message')}</p>
        <button className="email-verified-btn" onClick={() => navigate('/')}>
          {t('emailVerified.goHome')}
        </button>
      </div>
    </div>
  );
}

export default EmailVerified;